import { Box, Container, Grid, Typography } from '@mui/material';

export function Statistics({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const stats = Array.isArray(data.statistics) ? data.statistics : [];

  if (stats.length === 0) return null;

  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        backgroundColor: primaryColor,
        color: '#ffffff',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Background overlay accent */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'radial-gradient(circle at 80% 20%, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0) 60%)',
          pointerEvents: 'none',
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Grid container spacing={4} sx={{ justifyContent: 'center', alignItems: 'center' }}>
          {stats.map((stat, index) => (
            <Grid size={{ xs: 6, md: 3 }} key={index}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography
                  variant="h1"
                  fontWeight={900}
                  sx={{
                    fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem' },
                    lineHeight: 1,
                    letterSpacing: '-0.03em',
                    mb: 1,
                    color: '#ffffff',
                    textShadow: '0 4px 12px rgba(0,0,0,0.2)',
                  }}
                >
                  {stat.value}
                </Typography>
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  sx={{
                    opacity: 0.9,
                    fontSize: { xs: '0.9rem', md: '1.05rem' },
                    letterSpacing: '0.02em',
                  }}
                >
                  {stat.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Statistics;
